const templates = {
    //default article view
    crossmarkDialogTmpl: require('../../article-crossmark-badge/templates/article-crossmark-badge/crossmark-pop-client.jade'),
    // xref links - references, footnotes...
    xrefLinks: require('../templates/parts/xref-links-client.jade'),
    // multi references popup
    referencesPopup: require('../templates/parts/reference-list-pop-up-client.jade'),
    // references render inside a ui-core dropblock
    dropBlockTmpl: require('../templates/parts/reference-dropblock-client.jade'),
    // collateral
    figureTmpl: require('../templates/parts/collateral-figure-client.jade'),
    // figure viewer
    fvFrame: require('../templates/figure-viewer/fv-frame-client.jade'),
    fvAsideInfo: require('../templates/figure-viewer/fv-asideInfo-client.jade'),
    fvAsideDownload: require('../templates/figure-viewer/fv-asideDownload-client.jade'),
    fvTopInfo: require('../templates/figure-viewer/fv-topInfo-client.jade'),
    fvDirectoryItem: require('../templates/figure-viewer/fv-directory-item-client.jade'),
    fvLightboxFigures: require('../templates/figure-viewer/fv-lightbox-client.jade'),
};

export default templates;
